import {stylesheet} from "typestyle";


export const dialogStyles = stylesheet({
    info: {
        padding: "1.5em",
        textAlign: "center",
        backgroundColor: "#333",
        width: "15em",
    },
    action: {
        position: "relative",
        padding: "0.75em 0",
        width: "24em",
    },
    heading: {
        fontSize: "1.25em",
    },
    description: {
        marginTop: "1em",
        fontSize: "0.875em",
        opacity: 0.75,
    },
    button: {
        width: "100%",
        marginTop: "1em",
    }
});